"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

var _utils = require("../utils");

var _SubscriptionBlock = _interopRequireDefault(require("./SubscriptionBlock"));

var _AssignmentList = _interopRequireDefault(require("./AssignmentList"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var OrganisationManager = /*#__PURE__*/function (_Component) {
  _inherits(OrganisationManager, _Component);

  function OrganisationManager(props) {
    var _this;

    _classCallCheck(this, OrganisationManager);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OrganisationManager).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onSave", function () {
      var onSave = _this.props.onSave;

      _this.setState(function (_ref) {
        var currentManager = _ref.currentManager;
        return {
          assignedManager: currentManager
        };
      }, function () {
        var assignedManager = _this.state.assignedManager;
        onSave(assignedManager);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setAssignedManager", function (manager) {
      _this.setState(function (_ref2) {
        var currentManager = _ref2.currentManager;
        return {
          currentManager: currentManager && currentManager.userId === manager.userId ? void 0 : manager
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAssignModalToggle", function (_ref3) {
      var closed = _ref3.closed;

      if (closed) {
        _this.setState(function (_ref4) {
          var assignedManager = _ref4.assignedManager;
          return {
            currentManager: assignedManager
          };
        });
      }
    });

    var _manager = props.assignedManager || void 0;

    _this.state = {
      assignedManager: _manager,
      currentManager: _manager
    };
    return _this;
  }

  _createClass(OrganisationManager, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          currentManager = _this$state.currentManager,
          assignedManager = _this$state.assignedManager;
      var _this$props = this.props,
          title = _this$props.title,
          users = _this$props.users,
          id = _this$props.id,
          disabled = _this$props.disabled;
      return _react.default.createElement(_SubscriptionBlock.default, {
        id: id,
        title: title,
        defaultImage: "admin",
        assignmentType: "Managers",
        assignedDescriptions: assignedManager ? (0, _utils.buildUserDescription)(assignedManager) : void 0,
        assignedName: (0, _getUserFullName.default)(assignedManager),
        image: assignedManager && assignedManager.imageUrl,
        onSave: this.onSave,
        onToggleModal: this.handleAssignModalToggle,
        disabled: disabled,
        assignmentModalContent: _react.default.createElement(_AssignmentList.default, {
          list: users,
          onAssignItem: this.setAssignedManager,
          assignedItem: currentManager,
          assignmentMatchField: "userId",
          getItemDisplayName: _getUserFullName.default,
          getItemDescription: _utils.buildUserDescription
        })
      });
    }
  }]);

  return OrganisationManager;
}(_react.Component);

exports.default = OrganisationManager;